import {
  GET_FAQS_SUCCESS,
  GET_FAQS_FAIL,
  GET_FAQ_PROFILE_SUCCESS,
  GET_FAQ_PROFILE_FAIL,
  ADD_FAQ_SUCCESS,
  ADD_FAQ_FAIL,
  UPDATE_FAQ_SUCCESS,
  UPDATE_FAQ_FAIL,
  DELETE_FAQ_SUCCESS,
  DELETE_FAQ_FAIL,
  DELETE_FAQ,
  ADD_NEW_FAQ,
  UPDATE_FAQ
  
} from "./actionTypes";

const INIT_STATE = {
  faqs: [],
  faqProfile: {
    faq:{},
    types:[],
    settings:[],
    services:[]
  },
  error: {},
  loading:false
};

const faqs = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_FAQS_SUCCESS:
      return {
        ...state,
        faqs: action.payload.data,
        total_page:action.payload.total_page
      }

    case GET_FAQS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_NEW_FAQ:
        return {
          ...state,
          loading:true
        }
    case ADD_FAQ_SUCCESS:
      return {
        ...state,
        faqs: [...state.faqs, action.payload],
        loading:false
      }

    case ADD_FAQ_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_FAQ:
        return {
          ...state,
          loading:true
        }
    case UPDATE_FAQ_SUCCESS:
      return {
        ...state,
        faqs: state.faqs.map(faq =>
          faq.id.toString() === action.payload.id.toString()
            ? { ...faq, ...action.payload }
            : faq
        ),
        loading:false
      }

    case UPDATE_FAQ_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_FAQ:
      return {
        ...state,
        loading:true
      }
    case DELETE_FAQ_SUCCESS:
      return {
        ...state,
        faqs: state.faqs.filter(
          faq => faq.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_FAQ_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_FAQ_PROFILE_SUCCESS:
      return {
        ...state,
        faqProfile: action.payload,
      }

    case GET_FAQ_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default faqs;
